module.exports = __webpack_public_path__ + "static/media/insert.5007554d.ogg";